/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1099
 */

var r = require(/* 168 */"../1648/168")
var o = require(/* 954 */"../1648/761/954")
module.exports = function (e) {
  return r(function () {
    return !!o[e]() || "​᠎" != "​᠎"[e]() || o[e].name !== e
  })
}
